import script from "./ValidateSkillsWeb.vue?vue&type=script&setup=true&lang=js"
export * from "./ValidateSkillsWeb.vue?vue&type=script&setup=true&lang=js"

import "./ValidateSkillsWeb.vue?vue&type=style&index=0&id=7b2676c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b2676c8"]])

export default __exports__